/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finance_Nav_LabelInputs */

const en_finance_nav_label = /** @type {(inputs: Finance_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finances`)
};

const pl_finance_nav_label = /** @type {(inputs: Finance_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanse`)
};

/**
* | output |
* | --- |
* | "Finances" |
*
* @param {Finance_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const finance_nav_label = /** @type {((inputs?: Finance_Nav_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finance_Nav_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_finance_nav_label(inputs)
	return en_finance_nav_label(inputs)
});